import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, accessSession, deviceSession, saveAuth } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => { saveAuth(r.data); setUser(r.data); }).catch(() => { accessSession.clear(); deviceSession.clear(); setUser(false); }));
  }, []);

  const login = async (email, password) => {
    const isInstalledApp = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    const { data } = await api.post("/auth/login", { email, password }, { headers: isInstalledApp ? { "X-NasDeal-Primary-Device": "1" } : {} });
    saveAuth(data);
    setUser(data);
    return data;
  };
  const register = async (body) => {
    const { data } = await api.post("/auth/register", body);
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    accessSession.clear();
    deviceSession.clear();
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center eyebrow" data-testid="auth-loading">Chargement…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/connexion" replace />;
  return children;
}
